<div
  [ngSwitch]="template.templatePrefix"
  *ngIf="onboardingConfig | async as template"
>
  <!-- DSA welcome screen-->
  <div
    *ngSwitchCase="'dsa-'"
    class="grid l_flexbar m-l_flexbar-col __center-vertical"
    data-dgat="onboarding-welcomeLxp-2ea"
  >
    <div
      class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column no-mobile"
    >
      <img
        class="not-too-wide"
        [src]="getBlobUrl('/content/img/onboarding/mountain.png')"
        [srcset]="getBlobUrl('/content/img/onboarding/mountain-2x.png')"
        [alt]="i18n.Onboarding_WelcomeMountainIllustration"
      />
    </div>
    <div class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column">
      <h1 class="h1">{{ i18n.Onboarding_WelcomeHeading }}</h1>
      <p class="par guts-p-t-1">{{ onboarding_WelcomeDetails }}</p>
    </div>
    <div
      class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column mobile-only"
    >
      <img
        class="not-too-wide"
        [src]="getBlobUrl('/content/img/onboarding/mountain.png')"
        [srcset]="getBlobUrl('/content/img/onboarding/mountain-2x.png')"
        [alt]="i18n.Onboarding_WelcomeMountainIllustration"
      />
    </div>
  </div>

  <!-- HMM spark welcome screen hmm is only in english -->
  <div *ngSwitchCase="'hmm-'" class="grid">
    <div class="center-fixed-logo guts-p-full-2">
      <a [routerLink]="['/getstarted/skills']" data-dgat="hmm-step1-4a1">
        <img
          class="not-too-wide"
          [src]="getBlobUrl('/content/img/onboarding/hmm-spark-splash.png')"
          alt="Spark | Learn Grow Lead | Master New Business Skills - Your Way"
        />
      </a>
    </div>
  </div>

  <!-- default lxp -->
  <div
    *ngSwitchDefault
    class="grid l_flexbar m-l_flexbar-col __center-vertical"
    data-dgat="onboarding-welcomeLxp-2ea"
  >
    <div
      class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column no-mobile"
    >
      <img
        class="not-too-wide"
        [src]="getBlobUrl('/content/img/onboarding/mountain.png')"
        [srcset]="getBlobUrl('/content/img/onboarding/mountain-2x.png')"
        [alt]="i18n.Onboarding_WelcomeMountainIllustration"
      />
    </div>
    <div class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column">
      <h1 class="h1" tabindex="-1" dgxAutofocus>
        {{ i18n.Onboarding_WelcomeHeading }}
      </h1>
      <p class="par guts-p-t-1">{{ onboarding_WelcomeDetails }}</p>
    </div>
    <div
      class="grid__col-md-6 grid__col-sm-6 grid__col-xs-12 l_flex-column mobile-only"
    >
      <img
        class="not-too-wide"
        [src]="getBlobUrl('/content/img/onboarding/mountain.png')"
        [srcset]="getBlobUrl('/content/img/onboarding/mountain-2x.png')"
        [alt]="i18n.Onboarding_WelcomeMountainIllustration"
      />
    </div>
  </div>
</div>
